import { API_GET_STREETS_POSTALCODE } from 'actions/street.js';

export function getStreetsByPostalCode(postalCodeId, work = false) {
	return {
		type: API_GET_STREETS_POSTALCODE,
		work,
		payload: {
			request: {
				url: `/streets/postalCode/${postalCodeId}/`,
				method: 'GET',
			},
		},
	};
}
